export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAHElEQVR42mNgYGD4TyFm+E8uGDVg1ADqGkAJBgCfYmG7bLnyEwAAAABJRU5ErkJggg=="